export default "__VITE_ASSET__DJ_f6THC__"